import { useContext } from 'react';
import authContext from '../context/autenticacion/authContext'
import { useT } from 'i18n';

const Alerta = () => {
    const { ts } = useT();
    

    const AuthContext = useContext(authContext);
    const { mensaje } = AuthContext;




    return ( 

            <div className="alerta-panther pt-2 pb-2">
                {ts(mensaje)}
            </div>
     );
}
 
export default Alerta;